
import { PassengerType, PassengerStatus } from "../../constants/settings";

export function isAllSeatSelected(booking) {
  if (!booking) return false;

  const { passengers, segments } = booking;
  if (!Array.isArray(passengers) || !Array.isArray(segments)) return false;

  let extraCount = 0, extraSelected = 0, totalCount = 0, totalSelected = 0;

  segments.forEach(segment => {
    if (!Array.isArray(segment.legs)) return;
    segment.legs.forEach(leg => {
      if (!Array.isArray(leg.customers)) {
        return;
      }

      leg.customers.forEach(customer => {
        if (customer.status !== PassengerStatus.CheckingIn) return;

        const pax = passengers.find(x => x.id === customer.passengerId);
        if (!pax || pax.paxType === PassengerType.Infant) return;

        if (pax.paxType === PassengerType.ExtraSeat)
          extraCount++;
        else
          totalCount++;

        if (customer.seat) {
          if (pax.paxType === PassengerType.ExtraSeat)
            extraSelected++;
          else
            totalSelected++;
        }
      })
    })
  })

  return totalSelected === totalCount && extraSelected === extraCount
}